module.exports = __webpack_public_path__ + "img/grip-horizontal.e549f80a.svg";